import { $userViewInfo } from './stores.js';
import { getUserFx } from './effects.js';

$userViewInfo.on(getUserFx.doneData, (_, payload) => payload.object.result);
